<template>
  <CContainer fluid>
    <CRow class="justify-content-center" >
      <CCol >
        <CCol>
          <div class="card">
            <div class="card-body">
              <b><h3> IKID SCAN </h3></b>
                <h5 style="color:grey;">Scan your Kid QR Code</h5>
              <CRow class="mt-3">
                <CCol sm="9" >
                  <b-input  placeholder="If the QR Code is not working, please click here then scan again." ref="text" v-model="form.value" id="feedback-user" class="mb-1" @input="changeHandler" @blur.prevent="focusTextbox"> </b-input>
                </CCol>
                <CCol >
                  <CButton block color="info" @click="scan">Scan</CButton>
                  <alertmodal></alertmodal>
                </CCol>
                <CCol>
                  <CButton block color="warning" @click="clearPage">Clear</CButton>
                </CCol>
              </CRow>
              <strong id="error"></strong>
            </div>
          </div>
        </CCol>
      </CCol>
    </CRow>
    <div v-if="data">
    <CRow class="mb-4 ml-1" v-if="data.filter(item => item.checkin_status !== null && item.checkin_status.action == 'check in').length > 1">
      <CCol sm="2">
        <CButton block @click=" openSelectAll()"  variant="primary" color="primary">Select All</CButton>
      </CCol>
      <CCol sm="2">
        <CButton block @click=" selectedItems = []"  variant="primary" color="primary">Unselect All</CButton>
      </CCol>
      <CCol sm="2">
        <CRow v-if="selectedItems.length > 1">
          <CCol>
            <CButton block @click="presentAll(selectedItems)"  variant="primary" color="warning">Present</CButton>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
        <CRow lg="12">
          <CCol lg="6" v-for="item in data" :key="item.id" v-if="item.checkin_status !== null && (item.checkin_status.action == 'check in' || item.checkin_status.action == 'in class' || item.checkin_status.action == 'queued')">
            <CCol >
              <CCard
                class="card-kids"
                :class="{selected: isSelected(item.id), disabled: isDisabled(item.checkin_status)}" @click="handleSelect(item)"
              >
                <CRow>
                  <CCol>
                    <CCardBody>
                      <CRow>
                        <img v-bind:src="getPhoto(item.get_photo)" class="c-avatar-img-scan justify-content-start">
                          <CCol>
                            <CCallout v-if="item.checkin_status == null" color="secondary">
                          <row >
                            <h5><CBadge v-if="item.checkin_status == null" color="secondary">Unconfirmed</CBadge></h5>
                            <p> Name: <b> {{item.firstname + " " + item.lastname}} </b></p>
                            <p> Gender:<b>{{item.sex}}</b> </p>
                            <p> Class: <b>{{ item.ikid_class.name }} </b> </p>
                            <p v-if="item.dad_people_uuid && !item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname }}</b>
                            </p>
                            <p v-else-if="!item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            <p v-else-if="item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname + ' and ' + item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                          </row>
                        </CCallout>
                        <CCallout v-else-if="item.checkin_status !== null && item.checkin_status.action == 'check in'" color="info">
                          <row >
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'check in'" color="info">Ready For Checkin</CBadge></h5>
                            <p> Name: <b> {{item.firstname + " " + item.lastname}} </b></p>
                            <p> Gender:<b>{{item.sex}}</b> </p>
                            <p> Class: <b>{{ item.ikid_class.name }} </b> </p>
                            <p v-if="item.dad_people_uuid && !item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname }}</b>
                            </p>
                            <p v-else-if="!item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            <p v-else-if="item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname + ' and ' + item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                          </row>
                        </CCallout>
                        <CCallout v-else-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" color="success">
                          <row >
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" color="success">In Class</CBadge></h5>
                            <p> Name: <b> {{item.firstname + " " + item.lastname}} </b></p>
                            <p> Gender:<b>{{item.sex}}</b> </p>
                            <p> Class: <b>{{ item.ikid_class.name }} </b> </p>
                            <p v-if="item.dad_people_uuid && !item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname }}</b>
                            </p>
                            <p v-else-if="!item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            <p v-else-if="item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname + ' and ' + item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                          </row>
                        </CCallout>
                        <CCallout v-else-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" color="success">
                          <row >
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" color="success">In Queued</CBadge></h5>
                            <p> Name: <b> {{item.firstname + " " + item.lastname}} </b></p>
                            <p> Gender:<b>{{item.sex}}</b> </p>
                            <p> Class: <b>{{ item.ikid_class.name }} </b> </p>
                            <p v-if="item.dad_people_uuid && !item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname }}</b>
                            </p>
                            <p v-else-if="!item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            <p v-else-if="item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname + ' and ' + item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                          </row>
                        </CCallout>
                        <CCallout v-else="item.checkin_status !== null && item.checkin_status.action == 'check out'" color="danger">
                          <row >
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'check out'" color="danger">Check out</CBadge></h5>
                            <p> Name: <b> {{item.firstname + " " + item.lastname}} </b></p>
                            <p> Gender:<b>{{item.sex}}</b> </p>
                            <p> Class: <b>{{ item.ikid_class.name }} </b> </p>
                            <p v-if="item.dad_people_uuid && !item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname }}</b>
                            </p>
                            <p v-else-if="!item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            <p v-else-if="item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname + ' and ' + item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                          </row>
                        </CCallout>
                          <CButton  v-if="item.checkin_status == null || item.checkin_status.action == 'check out'" block @click="openCheck(item.id)"  variant="primary" color="success">Check In</CButton>
                          <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'check in'" block @click=" openPresent(item.id)"  variant="primary" color="warning">Present </CButton>
                          <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" block @click=" openQueue(item.id)"  variant="primary" color="warning">To Queue</CButton>
                          <!-- <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" block @click=" openForceCheckOut(item.id)"  variant="primary" color="warning">Check Out</CButton> -->
                          <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" block @click=" openCheckOut(item.id)"  variant="primary" color="warning">Check Out</CButton>
                          <!-- <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" block @click=" openQueue(item.id)"  variant="primary" color="warning">Queue</CButton> -->
                          <!-- <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'check in'" block @click="(item.uuid)"  variant="outline" color="secondary">Cancel </CButton> -->
                          <!-- <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" block @click="openCheckOut(item.uuid)"  variant="primary" color="danger">Check Out </CButton>
                          <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" block @click="(item.uuid)"  variant="outline" color="secondary">Cancel </CButton> -->
                          <!-- <CButton  v-else-if="item.checkin_status !== null && item.checkin_status.action == 'check out'" block  variant="primary" color="secondary">Already Attend </CButton> -->
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCol>
              </CRow>
            </CCard>
          </CCol>
        </CCol>
    </CRow>
    </div>
    <ikidmodal></ikidmodal>
    <ikidmodalqueue></ikidmodalqueue>
    <ikidmodalcheckout></ikidmodalcheckout>
    <!-- <pre>{{ $data | json }}</pre> -->
  </CContainer>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

import axios from 'axios'
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';
import ikid from '@/services/ikid'

import ikidmodal from './ikidsmodal_checkin.vue';
import ikidmodalqueue from './kids_queue_check.vue';
import ikidmodalcheckout from './kids_checkout.vue';
import { sendMessageToDiscord } from '@/discordUtils';
import QRCode from 'qrcode';
import moment from 'moment';


export default {

  components: { QrcodeStream, alertmodal, ikidmodal,ikidmodalcheckout,ikidmodalqueue, },

  data () {
    return {
      data:[],
      id: '',
      class_id: [],
      class_name: [],
      dad_id: [],
      dad_name: [],
      mom_id:[],
      mom_name:[],
      form:{
        value: '',
        from:'portal',
      },
      value: '',
      error: '',
      camera_hide: false,
      result_hide: true,
      message: '',
      message_hide: true,
      loading_submit: false,
      selectedItems: [],
      contentPrint: [],
    }
  },

  created(){
      ikid.getIkidClass().then(res => {
        for (let i = 0; i <= res.data.length - 1; i++) {
            this.class_id.push(res.data[i].id);
            this.class_name.push(res.data[i].name);
         }
        });
        ikid.getIkidParent().then(res => {
        for (let i = 0; i <= res.dad.length - 1; i++) {
          this.dad_id.push(res.dad[i].id);
          this.dad_name.push(res.dad[i].firstname + ' ' + res.dad[i].lastname);
         }
         for (let i = 0; i <= res.mom.length - 1; i++) {
          this.mom_id.push( res.mom[i].id);
          this.mom_name.push( res.mom[i].firstname + ' ' + res.mom[i].lastname);
         }
        });
  },

  mounted(){
    this.$refs.text.$el.focus();
      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
        this.scan();
      }
      });



    // var self = this;
    // window.addEventListener('keyup', function(event) {
    //   if (event.keyCode === 13) {
    //     //alert('press enter')
    //     self.check123();
    //   }
    // });



  },

  methods: {
    scan: function () {
      // this.camera_hide = false;
      // this.result_hide = true;
      this.loading_submit = true
      var temp_input = this.form.value;
      var self = this;
      if (this.form.value) {
        this.form.value = this.form.value.toUpperCase();
      }
        ikid.scanKid({value:this.form.value})
        .then(res => {
            this.data = res.data;
            this.id = res.data.id;
            this.camera_hide = true;
            this.result_hide = false;
            self.form.firstname = res.data[0].firstname;
            self.form.lastname = res.data[0].lastname;
            self.form.sex = res.data[0].sex;
            self.form.profilepic = res.data[0].profilepic;
            self.form.class_id = res.data[0].class_id;
            self.form.dad_id = res.data[0].dad_id;
            self.form.mom_id = res.data[0].mom_id;
            error.innerHTML = "<span style='color: green;'>"+
            "Success - Recorded KIDS Successfully</span>"
            this.form.value = null
            this.loading_submit = false
            if (this.data.length == 0) {
              this.$refs.text.$el.focus();
            }
            this.openSelectAll()

            // check qr valid
            var is_valid = false;
            for (let i = 0; i <= this.data.length - 1; i++) {
              if ((this.data[i].checkin_status !== null && (this.data[i].checkin_status.action == 'check in' || this.data[i].checkin_status.action == 'in class' || this.data[i].checkin_status.action == 'queued'))) {
                is_valid = true;
                break;
              }
              if (is_valid) {
                break;
              }
            }
            if (!is_valid) {
              error.innerHTML = "<span style='color: red;'>"+
              "Invalid QR Code. Please check in first using the mobile app</span>"
              this.camera_hide = true;
              this.form.value = null
              this.loading_submit = false
              this.$refs.text.$el.focus();
              sendMessageToDiscord("ikid scan", "scan", "err invalid qr | " + temp_input);
            }

        }).catch ((err) => {
            // var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            // EventBus.$emit('OPEN_MODAL_ALERT', params)
            // this.camera_hide = true;
            error.innerHTML = "<span style='color: red;'>"+
            "Error - KIDS Not Found. Please try again</span>"
            this.camera_hide = true;
            this.form.value = null
            this.loading_submit = false
            this.$refs.text.$el.focus();
            sendMessageToDiscord("ikid scan", "scan", "err | " + temp_input);
        })
    },

    openCheck: function(uuid) {
      // var params = {
      //       title: "Check In",
      //       mode: "detail",
      //       data: uuid
      //    };
      //    EventBus.$emit("OPEN_MODAL_IKID_CHECKIN", params);


      //     this.data = null
      //     this.form.value = null
      //     error.innerHTML = null
      //     this.$refs.text.$el.focus();


      // //SET END

      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 1;
        ikid.changeStatusKid(this.form)
        .then(res => {
          // EventBus.$emit('TABLE_UPDATE', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)

          this.data = null
          this.form.value = null
          error.innerHTML = null
          this.$refs.text.$el.focus();

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }


    },
    openPresent: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.contentPrint = []
        this.form.ikid_id = uuid;
        this.form.status = 2;

        const firstname = this.data.find(item => item.id === uuid).firstname;
        const lastname = this.data.find(item => item.id === uuid).lastname;
        const barcode = this.data.find(item => item.id === uuid).barcode;
        this.contentPrint.push({
          firstname: firstname,
          lastname: lastname,
          class_id: this.data.find(item => item.id === uuid).ikid_class.name,
          check_time: moment().format('DD/MM/YYYY HH:mm:ss'),
          barcode: barcode
        })
        ikid.changeStatusKid(this.form)
        .then(res => {
          // EventBus.$emit('TABLE_UPDATE', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)

          this.data = null
          this.form.value = null
          error.innerHTML = null
          this.$refs.text.$el.focus();

          // print qr code
          if(confirm("Do you want to print QR code?")){

            this.contentPrint.forEach((content, index) => {
              this.connectToPrinter(content.firstname, content.lastname, content.class_id, content.barcode);
            });

            // setTimeout(() => {
            //   const newWindow = window.open('', '_blank');

            //   // Start the HTML structure
            //   newWindow.document.write('<div style="font-family: Arial, sans-serif;">');

            //   this.contentPrint.forEach((content, index) => {
            //     newWindow.document.write('<div style="width: fit-content; padding: 10px; margin-bottom: 20px; border-radius: 4px; border: solid 1px #ccc; text-align: center;">');
            //     newWindow.document.write(`<div style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">IFGF KID PICK-UP CARD</div>`);
            //     newWindow.document.write(`<strong>${content.firstname} ${content.lastname}</strong> <br>`);
            //     newWindow.document.write(`Class : ${content.class_id} <br>`);
            //     newWindow.document.write(`Check In : ${content.check_time}`);
            //     newWindow.document.write('<hr>');
            //     newWindow.document.write('<center>');

            //     const qrCanvas = document.createElement('canvas');
            //     const qrCodeValue = content.barcode + '#';

            //     QRCode.toCanvas(qrCanvas, qrCodeValue, (error) => {
            //       if (error) {
            //         console.error(error);
            //         return;
            //       }
            //       const qrCodeImage = qrCanvas.toDataURL('image/png');

            //       newWindow.document.write('<img src="' + qrCodeImage + '" width="175" height="auto" />');
            //       newWindow.document.write('</center>');
            //       newWindow.document.write('</div>');

            //       // Close and print after the last content
            //       if (index === this.contentPrint.length - 1) {
            //         newWindow.document.write('</div>'); // Close main container
            //         newWindow.document.close();

            //         newWindow.onload = function() {
            //           newWindow.print();
            //         };
            //       }
            //     });
            //   });
            // });
          }
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },
    openQueue: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 3;
        ikid.changeStatusKid(this.form)
        .then(res => {
          // EventBus.$emit('TABLE_UPDATE', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)

          this.data = null
          this.form.value = null
          error.innerHTML = null
          this.$refs.text.$el.focus();

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },
    openCheckOut: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 4;
        ikid.changeStatusKid(this.form)
        .then(res => {
          // EventBus.$emit('TABLE_UPDATE', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)

          this.data = null
          this.form.value = null
          error.innerHTML = null
          this.$refs.text.$el.focus();

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },
    openForceCheckOut: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 3;
        ikid.changeStatusKid(this.form)
        .then(res => {

          setTimeout(() => {
            this.form.ikid_id = uuid;
            this.form.status = 4;
            ikid.changeStatusKid(this.form)
            .then(res => {
                // EventBus.$emit('TABLE_UPDATE', true)
                // var params = {title: 'Success', mode:'success', data:res.message}
                // EventBus.$emit('OPEN_MODAL_ALERT', params)

                this.data = null
                this.form.value = null
                error.innerHTML = null
                this.$refs.text.$el.focus();

            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }, 1000);


        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },
    presentAll: function() {
        this.contentPrint = []
        Promise.all(
          this.selectedItems.map(i => {
          this.form.ikid_id = i;
          // console.log(i);
          const firstname = this.data.find(item => item.id === i).firstname;
          const lastname = this.data.find(item => item.id === i).lastname;
          const barcode = this.data.find(item => item.id === i).barcode;
          // console.log(firstname + ' ' + lastname);
          this.contentPrint.push({
            firstname: firstname,
            lastname: lastname,
            class_id: this.data.find(item => item.id === i).ikid_class.name,
            check_time: moment().format('DD/MM/YYYY HH:mm:ss'),
            barcode: barcode
          })
          this.form.status = 2;
          ikid.changeStatusKid(this.form)
        .then(res => {
        // var params = {title: 'Success', mode:'success', data:res.message}
        // EventBus.$emit('OPEN_MODAL_ALERT', params)
        // EventBus.$emit('TABLE_UPDATE', false)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        })
      )
      .then(res => {
          this.data = []
          // EventBus.$emit('TABLE_UPDATE', true)
          this.form.value = ''
          error.innerHTML = null
          this.$refs.text.$el.focus();
          this.selectedItems = []


          // print qr code
          if(confirm("Do you want to print QR code?")){

            this.contentPrint.forEach((content, index) => {
              this.connectToPrinter(content.firstname, content.lastname, content.class_id, content.barcode);
            });

            // setTimeout(() => {
            //   const newWindow = window.open('', '_blank');

            //   // Start the HTML structure
            //   newWindow.document.write('<div style="font-family: Arial, sans-serif;">');

            //   this.contentPrint.forEach((content, index) => {
            //     newWindow.document.write('<div style="width: fit-content; padding: 10px; margin-bottom: 20px; border-radius: 4px; border: solid 1px #ccc; text-align: center;">');
            //     newWindow.document.write(`<div style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">IFGF KID PICK-UP CARD</div>`);
            //     newWindow.document.write(`<strong>${content.firstname} ${content.lastname}</strong> <br>`);
            //     newWindow.document.write(`Class : ${content.class_id} <br>`);
            //     newWindow.document.write(`Check In : ${content.check_time}`);
            //     newWindow.document.write('<hr>');
            //     newWindow.document.write('<center>');

            //     const qrCanvas = document.createElement('canvas');
            //     const qrCodeValue = content.barcode + '#';

            //     QRCode.toCanvas(qrCanvas, qrCodeValue, (error) => {
            //       if (error) {
            //         console.error(error);
            //         return;
            //       }
            //       const qrCodeImage = qrCanvas.toDataURL('image/png');

            //       newWindow.document.write('<img src="' + qrCodeImage + '" width="175" height="auto" />');
            //       newWindow.document.write('</center>');
            //       newWindow.document.write('</div>');

            //       // Close and print after the last content
            //       if (index === this.contentPrint.length - 1) {
            //         newWindow.document.write('</div>'); // Close main container
            //         newWindow.document.close();

            //         newWindow.onload = function() {
            //           newWindow.print();
            //         };
            //       }
            //     });
            //   });
            // });
          }
      })
      .catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
    })
    },
    getPhoto(data) {
      if (data === null || data === ' '){
        return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } else {
        return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
      }
    },

    check123(){
      if(this.result_hide === false){
        //alert('yes');
        this.submit();
      }
    },
    focusTextbox() {
      if (!this.loading_submit) {
        this.$refs.text.$el.focus();
      }
    },

  //   mounted (){
  //     this.scan()
  //   EventBus.$on('TABLE_UPDATE', (data) => {
  //     if(data){
  //       this.scan();
  //     }
  //   });

  //  },

    changeHandler: function () {
      // if(this.form.value.length > 0){
      //   error.innerHTML = "<span'>"+
      //       "Loading...</span>"
      //   setTimeout(this.scan, 1500);
      // }

      // prevent double input on scan
      if (this.form.value.length > 0 && this.form.value.endsWith('#')) {
        this.form.value = this.form.value.slice(0, -1);
        this.loading_submit = true
        this.$refs.text.$el.blur();
        error.innerHTML = "<span'>"+
            "Loading...</span>"
        setTimeout(this.scan, 1500);
      }
    },
    messageInvalidFeedback: function(max) {
      return "Maksimal " + max + " tiket"
    },
    submit(){
      //alert('asd');
      this.loading_submit = true
      ikid.scanKid(this.id, this.form)
      .then(res => {
          console.log(res.meesage)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          this.camera_hide = false;
          this.result_hide = true;
          this.loading_submit = false
          this.$refs.text.$el.focus();
      }).catch ((err) => {
          this.loading_submit = false
          console.log(err.response.data.message)
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            this.$refs.text.$el.focus();

      })
    },


      getClassName(temp) {
         return this.class_name[this.class_id.indexOf(temp)];
      },
      getDadName(temp) {
         return this.dad_name[this.dad_id.indexOf(temp)];
      },
      getMomName(temp) {
         return this.mom_name[this.mom_id.indexOf(temp)];
      },
      clearPage() {
        this.data = null
        this.form.value = null
        error.innerHTML = null
        this.selectedItems = []
        this.$refs.text.$el.focus();
      },
      openSelectAll:function () {
        if (this.data.filter(item => item.checkin_status && item.checkin_status.action === 'check in').length <= 1) return
        const dataKid = this.data
        .filter(i => i.checkin_status && i.checkin_status.action === 'check in')
        .map(i => i.id);
        this.selectedItems = dataKid
      },
      handleSelect(data){
        if (data.checkin_status.action == 'check out' || data.checkin_status.action == 'in class' || data.checkin_status.action == 'queued' ) return
        if (this.data.filter(item => item.checkin_status && item.checkin_status.action === 'check in').length <= 1) return
        const isExist = this.selectedItems.find(i => i === data.id)
        if(isExist){
          this.selectedItems = this.selectedItems.filter(i => i !== data.id)
        }else{
          this.selectedItems.push(data.id)
        }
      },
      isSelected(id){
        const isExist = this.selectedItems.find(i => i === id)
        return !!isExist
      },
      isDisabled(data){
        if(data && data.action){
          // if(data.action === 'in class' || data.action === 'queued') return true
          return false
        }
        return false
      },
      async connectToPrinter(firstname, lastname, class_id, barcode) {
        // const firstname = firstname;
        // const lastname = lastname;
        // const class_id = class_id;
        const check_time = moment().format('DD/MM/YYYY HH:mm:ss');
        // const barcode = barcode + '#';

        try {
          const response = await axios.post('http://localhost:3000/print', {
            firstname: firstname,
            lastname: lastname,
            class_id: class_id,
            check_time: check_time,
            barcode: barcode
          },
          {
            timeout: 5000, // Timeout set to 5000ms (5 seconds)
          });
        } catch (error) {
          console.log('Error connecting to printer:', error);
          console.log('ID:', id);
        }
      },


  }
}
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
.card-checkbox{
  width: 25px;
  height: 25px;
}
.selected {
  box-shadow: 0 0 15px #007bff;
  transition: 0.2s;
}

.disabled {
  opacity: 0.5;
}

.card-kids{
  transition: 0.3s !important;
  height: 20rem;
}
</style>